/* unplugin-vue-components disabled */import script from "./reward_buy_right_rule.vue?vue&type=script&setup=true&lang=js"
export * from "./reward_buy_right_rule.vue?vue&type=script&setup=true&lang=js"

import "./reward_buy_right_rule.vue?vue&type=style&index=0&id=26105ce0&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26105ce0"]])

export default __exports__